import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from "@coreui/react-pro";
import { Formik } from "formik";
import { useEffect } from "react";
import * as Yup from "yup";
import SModal from "../../shared/Modal/SModal";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { AppDispatch } from "../../../store";
import { ToastSuccess } from "../../shared/toast/Toast";
import { createEntity, updateEntity } from "./injectionManagement.api";
import { fetching, resetEntity } from "./injectionManagement.reducer";
import { IInjection, INewInjection } from "@/shared/model/injection.model";
import { InjectionResponseStatus } from "@/shared/enumeration/InjectionResponseStatus";
import Select, { SingleValue } from "react-select";
import { ISelectValue } from "../../../shared/shared-interfaces";
import { IUser } from "@/shared/model/user.model";
import { userSelectors } from "../UserManagement/usersManagement.reducer";
import { getEntities as getEntitiesUsers } from "../UserManagement/usersManagement.api";

interface IInjectionUpdateProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  injectionObj?: IInjection;
}

const InjectionUpdate = (props: IInjectionUpdateProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.injectionsReducer
  );
  const { updateEntitySuccess } = initialState;
  const { visible, setVisible, injectionObj } = props;
  const handleOnClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (updateEntitySuccess) {
      setVisible(false);
      ToastSuccess(
        injectionObj ? "Cập nhật tiêm đơn thành công" : "Tiêm đơn thành công"
      );
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  const initialValues: INewInjection = {
    userId: 0,
    orderId: 0,
    thuTu: 0,
    rate: 0,
    status: InjectionResponseStatus.ACTIVE,
  };

  const validationSchema = Yup.object().shape({
    rate: Yup.number()
      .min(1.1, "Vui lòng nhập tỷ lệ lớn hơn 1.1")
      .required("Không được để trống"),
    thuTu: Yup.number().required("Không được để trống"),
    userId: Yup.number().required("Không được để trống"),
  });

  const returnOption = (
    optionValue: number | null | undefined,
    array: ISelectValue<string>[]
  ) => {
    if (!optionValue) return null;
    if (!array.length) return null;
    return array.find(({ value }) => Number(value) === optionValue);
  };

  const returnLevelItem = (items: IUser[], selectLevel?: IUser | null) => {
    return items.map((item) => {
      return {
        value: item.id,
        label: item.username + ` - ${item?.level?.name} ` +  " - Đơn hiện tại " + item.totalOrder,
      };
    });
  };
  const users = useSelector(userSelectors.selectAll);

  const customUserItems: any = returnLevelItem(users);

  useEffect(() => {
    dispatch(getEntitiesUsers({ page: 1, limit: 1000, sortBy: 'totalOrder', sortOrder: 'DESC' }));
  }, []);

  return (
    <SModal
      visible={visible}
      onClose={handleOnClose}
      backdrop="static"
      className="custom-modal"
    >
      <Formik
        initialValues={injectionObj || initialValues}
        validationSchema={validationSchema}
        // validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (value) => {
          dispatch(fetching());
          if (injectionObj) {
            dispatch(updateEntity(value as IInjection));
          } else {
            dispatch(createEntity(value));
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
        }) => (
          <CForm onSubmit={handleSubmit} className="custom-form">
            <>
              <CModalHeader>
                {injectionObj ? "Chỉnh sửa tiêm đơn" : "Tiêm đơn"}
              </CModalHeader>
              <CModalBody>
                <CRow className="g-3">
                  <CCol xs="12">
                    <CFormLabel className="mb-6 label-gray-700">
                      Tiêm đơn cho thành viên
                    </CFormLabel>

                    <Select
                      defaultValue={null}
                      className="custom-select form-height-44"
                      classNamePrefix="react-select"
                      value={
                        returnOption(
                          values.userId as any,
                          customUserItems
                        ) as any
                      }
                      onChange={(
                        newValue: SingleValue<ISelectValue<string>>
                      ) => {
                        setFieldValue(`userId`, newValue?.value || "");
                      }}
                      noOptionsMessage={() => <>Không có cấp độ</>}
                      id={"userId"}
                      options={customUserItems}
                      placeholder={"Chọn thành viên"}
                      isClearable={true}
                      closeMenuOnSelect={true}
                      menuPosition={"absolute"}
                      name="userId"
                    />

                    <CFormFeedback
                      invalid
                      className={
                        !!errors.userId && touched.userId ? "d-block" : "d-none"
                      }
                    >
                      {errors.userId}
                    </CFormFeedback>
                  </CCol>

                  <CCol xs="6">
                    <CFormLabel className="mb-6 label-gray-700">
                      Tỷ lệ
                    </CFormLabel>
                    <CFormInput
                      className="form-height-44"
                      name="rate"
                      value={values.rate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.rate && touched.rate}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.rate && touched.rate ? "d-block" : "d-none"
                      }
                    >
                      {errors.rate}
                    </CFormFeedback>
                  </CCol>

                  <CCol xs="6">
                    <CFormLabel className="mb-6 label-gray-700">
                      Đơn thứ
                    </CFormLabel>
                    <CFormInput
                      className="form-height-44"
                      name="thuTu"
                      value={values.thuTu}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.thuTu && touched.thuTu}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.thuTu && touched.thuTu ? "d-block" : "d-none"
                      }
                    >
                      {errors.thuTu}
                    </CFormFeedback>
                  </CCol>
                </CRow>
              </CModalBody>
              <CModalFooter className="d-flex justify-content-end">
                <CButton
                  className="btn-custom minw-120 variant-gray-300"
                  type="button"
                  onClick={() => {
                    resetForm();
                    setVisible(false);
                  }}
                >
                  Huỷ
                </CButton>
                <CButton
                  className="btn-custom minw-120 primary-500"
                  type="submit"
                >
                  Lưu
                </CButton>
              </CModalFooter>
            </>
          </CForm>
        )}
      </Formik>
    </SModal>
  );
};

export default InjectionUpdate;
